export default __webpack_public_path__ + "static/media/profile.d3e579fd.svg";